export class VerificationBestOfCertificateDto {
    participantNumber: number;
    participantName: string;
    dateOfBirth: Date;

    leScore: number;
    leTdn: string;

    hoScore: number;
    hoTdn: string;

    scScore: number;
    scTdn: string;

    spScore: number;
    spTdn: string;

    totalScore: number;
    totalTdn: string;

    verified: boolean;
}